import { formatCurrency } from '@/utils/libranzasFormat';
import './libranzasResumen.scss';

interface LibranzasResumenProps {
    documentoEmpresa: string;
    nombreEmpresa: string;
    total: number;
}

const LibranzasResumen = ({ documentoEmpresa, nombreEmpresa, total }: LibranzasResumenProps) => (
    <div className="m-libranzas-resumen">
        <div className="m-libranzas-resumen__heading">
            <h2 className="m-libranzas-resumen__heading__title">Resumen de pagos</h2>
        </div>
        <table className="m-libranzas-resumen__table">
            <tbody>
                <tr>
                    <th>Número documento empresa</th>
                    <th>Nombre empresa</th>
                    <th>Valor a pagar</th>
                </tr>
                <tr>
                    <td>{documentoEmpresa}</td>
                    <td>{nombreEmpresa}</td>
                    <td>{formatCurrency(total.toString())}</td>
                </tr>
            </tbody>
        </table>
    </div>
);

export default LibranzasResumen;
